import { VcsProvider } from "types/generated";

import { IntegrationId } from "../../constants";

export const VCS_INTEGRATIONS_LIST_FILTERS_KEY = "VCSIntegrationsListFiltersKey";

export const MULTIPLE_VCS_PROVIDERS = {
  [VcsProvider.AzureDevops]: VcsProvider.AzureDevops,
  [VcsProvider.BitbucketCloud]: VcsProvider.BitbucketCloud,
  [VcsProvider.BitbucketDatacenter]: VcsProvider.BitbucketDatacenter,
  [VcsProvider.GithubEnterprise]: VcsProvider.GithubEnterprise,
  [VcsProvider.Github]: VcsProvider.Github,
  [VcsProvider.Gitlab]: VcsProvider.Gitlab,
};

// export enum VCS_INTEGRATION_TYPES {
//   DEFAULT = "default",
//   MULTIPLE = "multiple",
// }

export const URL_KEY_AZURE_DEVOPS = IntegrationId.AZURE_DEVOPS;
export const URL_KEY_BITBUCKET_CLOUD = IntegrationId.BITBUCKET_CLOUD;
export const URL_KEY_BITBUCKET_DATACENTER = IntegrationId.BITBUCKET_DATA_CENTER;
export const URL_KEY_GITLAB = IntegrationId.GITLAB;
export const URL_KEY_GITHUB_ENTERPRISE = IntegrationId.GITHUB;
export const URL_KEY_GITHUB = IntegrationId.GITHUB;

export const VCS_PROVIDERS_URL_KEYS = {
  [MULTIPLE_VCS_PROVIDERS.AZURE_DEVOPS]: URL_KEY_AZURE_DEVOPS,
  [MULTIPLE_VCS_PROVIDERS.BITBUCKET_CLOUD]: URL_KEY_BITBUCKET_CLOUD,
  [MULTIPLE_VCS_PROVIDERS.BITBUCKET_DATACENTER]: URL_KEY_BITBUCKET_DATACENTER,
  [MULTIPLE_VCS_PROVIDERS.GITLAB]: URL_KEY_GITLAB,
  // Github and Github Enterprise are handled in the same integration screen, but they use different URLs
  // in the edit forms screen. We have to manually handle this case in the getEditIntegrationURL function.
  [MULTIPLE_VCS_PROVIDERS.GITHUB_ENTERPRISE]: "github-enterprise",
  [MULTIPLE_VCS_PROVIDERS.GITHUB]: URL_KEY_GITHUB,
};

export const VCS_INTEGRATIONS_PATH = "/vcs/integrations";
export const INTEGRATIONS_FILTER_PATH =
  "/integrations?filterKeys=categories&filterTypes=ENUM&filterValues=JTVCJTVCJTIyU291cmNlJTIwY29kZSUyMiU1RCU1RA%3D%3D";
